import {
	IsArray,
	IsBoolean,
	IsDateString,
	IsEnum,
	IsNotEmpty,
	IsNumber,
	IsOptional,
	IsString,
	IsUUID,
	Min,
} from 'class-validator';
import { MarketStatus } from '../../enums';

export class BaseMarketDto {
	@IsString()
	@IsNotEmpty()
	question: string;

	@IsNumber()
	@Min(0)
	initial_value: number;

	@IsNumber()
	@Min(0)
	current_value: number;

	@IsOptional()
	@IsUUID('4')
	match_id?: string | null;

	@IsOptional()
	@IsUUID('4')
	category_id?: string | null;

	@IsOptional()
	@IsString()
	context?: string | null;

	@IsOptional()
	@IsEnum(MarketStatus)
	status?: MarketStatus;

	@IsOptional()
	@IsNumber()
	@Min(0)
	priority?: number;

	@IsOptional()
	@IsNumber()
	@Min(0)
	market_open_delay?: number;

	@IsOptional()
	@IsDateString()
	opening_time?: string | null;

	@IsOptional()
	@IsDateString()
	closing_date?: string | null;

	@IsOptional()
	@IsNumber()
	stat_threshold?: number | null;

	@IsDateString()
	start_date: string;

	@IsOptional()
	@IsDateString()
	game_start_date?: Date | null;

	@IsOptional()
	@IsDateString()
	trade_start_at?: Date | null;

	@IsOptional()
	@IsString()
	ext_api_market_id?: string | null;

	@IsOptional()
	@IsBoolean()
	is_second_chance?: boolean;

	@IsOptional()
	@IsString()
	ext_api_market?: string | null;

	@IsOptional()
	@IsString()
	ext_api_name?: string | null;

	// Array of lobby IDs to associate this market with.
	// If omitted or empty, the market will be associated with all active lobbies in the event.
	@IsOptional()
	@IsArray()
	@IsUUID('4', { each: true })
	lobby_ids?: string[];
}

export class CreateMarketDto extends BaseMarketDto {
	@IsUUID('4')
	@IsNotEmpty()
	event_id: string;

	@IsOptional()
	@IsBoolean()
	is_settle_at_end?: boolean;
}

export class BulkCreateMarketItemDto extends BaseMarketDto {
	@IsOptional()
	@IsUUID('4')
	event_id?: string;
}
